/**
 * Tenant Context for tracking current tenant during navigation
 *
 * Uses Jotai's getDefaultStore to manage state outside of React components.
 * This solves the race condition where window.location still has the old tenant
 * during React Router navigation, but API requests need the new tenant ID.
 */

import { getDefaultStore } from "jotai";
import { currentTenantIdAtom } from "~/state/tenant";

const store = getDefaultStore();

/**
 * Set the current tenant ID during navigation
 * Called by middlewares before making API requests
 */
export const setCurrentTenantId = (tenantId: string | null): void => {
  store.set(currentTenantIdAtom, tenantId);
};

/**
 * Get the current tenant ID
 * Can be called from middlewares, loaders, and React components
 */
export const getCurrentTenantId = (): string | null => {
  return store.get(currentTenantIdAtom);
};
